import React, { Component } from "react";
import { Button, Col, Container, Row, Alert } from "reactstrap";
import selectn from "selectn";
import AppActions from "./../actions/AppActions";
import { get } from "./../lib/http";
import notifier from "./../lib/notifier";
import PlacementMode from "../lib/PlacementMode";
import _ from "lodash";
import ctrlS from "../lib/ctrlS";
import FormGroup from "./forms/FormGroup";
import BoundTextInput from "./forms/BoundTextInput";
import BoundEnumSelect from "./forms/BoundEnumSelect";
import BoundTextArea from "./forms/BoundTextArea";
import BoundDecimalInput from "./forms/BoundDecimalInput";
import { post } from "../lib/http";
import navigateTo from "../lib/navigateTo";
import connection from "./../lib/connection";
import BoundCheckbox from "./forms/BoundCheckbox";
import validateItem from "./../lib/validateItem";
import getColors from "./../lib/getColors";

export class Item extends Component {
  componentWillMount() {
    const id = selectn("match.params.id", this.props);

    this.update(id);
  }

  componentWillReceiveProps(nextProps) {
    const id = selectn("match.params.id", nextProps);
    if (id !== selectn("match.params.id", this.props)) {
      this.update(id);
    }
  }

  render() {
    const {
      item,
      connected,
      joined,
      step = 0.1,
      lockScale = true
    } = this.props;

    const onKeyDown = (event) => {
      ctrlS(event, () => {
        this.save();
      });
    };

    const {
      isValidMixId,
      isValidData,
      data,
      validateDataMessage
    } = validateItem(item);

    const colors = getColors(data);

    return (
      <Container>
        <h1>Item</h1>
        {item && item.id && <h3>{item.id}</h3>}
        {item && item.id && (
          <p>
            https://{window.location.host}/api/data/{item.mixId}/{item.id}
          </p>
        )}

        {/*<pre>{JSON.stringify(item, null, 2)}</pre>*/}

        {item && (
          <div onKeyDown={onKeyDown}>
            <FormGroup id="MixId" label="Mix id">
              <BoundTextInput
                value={item.mixId}
                path="item.mixId"
                id="MixId"
                className="form-control input-md"
              />
              {!isValidMixId && <Alert color="danger">Invalid id</Alert>}
              {isValidMixId && (
                <a
                  className="float-right"
                  href={`https://mixiply.com/app/mix/${item.mixId}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Open in Mixiply
                </a>
              )}
            </FormGroup>
            <FormGroup id="Description" label="Description">
              <BoundTextInput
                value={item.description}
                path="item.description"
                id="Description"
                className="form-control input-md"
                maxLength="512"
              />
            </FormGroup>
            <FormGroup id="Type" label="Type">
              <BoundTextInput
                value={item.type}
                path="item.type"
                id="Type"
                className="form-control input-md"
                maxLength="64"
              />
            </FormGroup>
            <FormGroup id="Layer" label="Layer">
              <BoundTextInput
                value={item.layer}
                path="item.layer"
                id="Layer"
                className="form-control input-md"
                maxLength="64"
              />
            </FormGroup>

            <FormGroup id="PlacementMode" label="Placement mode">
              <BoundEnumSelect
                enumType={PlacementMode}
                value={item.placementMode}
                path="item.placementMode"
                id="PlacementMode"
                className="form-control input-md"
                onChangeListener={(value, path) => this.onChange(value, path)}
              />
            </FormGroup>

            <Row form>
              <Col md={4}>
                <FormGroup id="Step" label="Step">
                  <BoundDecimalInput
                    value={step}
                    path="step"
                    id="step"
                    className="form-control"
                    step="0.1"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row form>
              <Col md={4}>
                <FormGroup id="PositionX" label="PositionX">
                  <BoundDecimalInput
                    value={item.positionX}
                    path="item.positionX"
                    id="PositionX"
                    className="form-control"
                    step={step}
                    onChangeListener={(value, path) =>
                      this.onChange(value, path)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup id="PositionY" label="PositionY">
                  <BoundDecimalInput
                    value={item.positionY}
                    path="item.positionY"
                    id="PositionY"
                    className="form-control"
                    step={step}
                    onChangeListener={(value, path) =>
                      this.onChange(value, path)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup id="PositionZ" label="PositionZ">
                  <BoundDecimalInput
                    value={item.positionZ}
                    path="item.positionZ"
                    id="PositionZ"
                    className="form-control"
                    step={step}
                    onChangeListener={(value, path) =>
                      this.onChange(value, path)
                    }
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row form>
              <Col md={4}>
                <FormGroup id="RotationX" label="RotationX">
                  <BoundDecimalInput
                    value={item.rotationX}
                    path="item.rotationX"
                    id="RotationX"
                    className="form-control"
                    step={step}
                    onChangeListener={(value, path) =>
                      this.onChange(value, path)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup id="RotationY" label="RotationY">
                  <BoundDecimalInput
                    value={item.rotationY}
                    path="item.rotationY"
                    id="RotationY"
                    className="form-control"
                    step={step}
                    onChangeListener={(value, path) =>
                      this.onChange(value, path)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup id="RotationZ" label="RotationZ">
                  <BoundDecimalInput
                    value={item.rotationZ}
                    path="item.rotationZ"
                    id="RotationZ"
                    className="form-control"
                    step={step}
                    onChangeListener={(value, path) =>
                      this.onChange(value, path)
                    }
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row form>
              <Col md={4}>
                <BoundCheckbox
                  checked={lockScale}
                  path="lockScale"
                  id="LockScale"
                  className="input-md"
                  inlineLabel="Lock scale"
                />
              </Col>
            </Row>

            <Row form>
              <Col md={4}>
                <FormGroup id="ScaleX" label="ScaleX">
                  <BoundDecimalInput
                    value={item.scaleX}
                    path="item.scaleX"
                    id="ScaleX"
                    className="form-control"
                    step={step}
                    onChangeListener={(value, path, oldValue) =>
                      this.onScaleChanged(value, path, oldValue)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup id="ScaleY" label="ScaleY">
                  <BoundDecimalInput
                    value={item.scaleY}
                    path="item.scaleY"
                    id="ScaleY"
                    className="form-control"
                    step={step}
                    onChangeListener={(value, path, oldValue) =>
                      this.onScaleChanged(value, path, oldValue)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup id="ScaleZ" label="ScaleZ">
                  <BoundDecimalInput
                    value={item.scaleZ}
                    path="item.scaleZ"
                    id="ScaleZ"
                    className="form-control"
                    step={step}
                    onChangeListener={(value, path, oldValue) =>
                      this.onScaleChanged(value, path, oldValue)
                    }
                  />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup id="Data" label="Data">
              <BoundTextArea
                value={item.data}
                path="item.data"
                id="Data"
                className="form-control"
              />
              {_.map(colors, (c) => (
                <div
                  key={c}
                  className="mt-3 mr-3"
                  style={{
                    height: "30px",
                    width: "30px",
                    backgroundColor: c
                  }}
                />
              ))}
              {!isValidData && (
                <Alert color="danger">{validateDataMessage}</Alert>
              )}
              <div className="clearfix" />
            </FormGroup>

            <div className="form-group">
              {connected && joined && item.id && (
                <Alert color="success">Joined {joined}</Alert>
              )}
              <Button
                color="primary"
                className="float-right"
                onClick={() => this.save()}
              >
                Save
              </Button>
            </div>
          </div>
        )}
      </Container>
    );
  }

  calcPc(n1, n2) {
    return (n2 - n1) / n1;
  }

  onScaleChanged(value, path, oldValue) {
    const { item, lockScale = true } = this.props;
    const property = path.split(".").pop();

    if (lockScale) {
      const pcChange = this.calcPc(oldValue, value);

      const applyChange = (propertyToChange) => {
        let newValue = item[propertyToChange] * (1 + pcChange);

        if (isNaN(newValue) || !isFinite(newValue)) {
          return;
        }

        newValue = Number(
          newValue.toLocaleString("fullwide", { maximumFractionDigits: 2 })
        );

        const newValuePath = `item.${propertyToChange}`;
        AppActions.updateState(newValuePath, newValue);
        this.onChange(newValue, newValuePath);
      };

      switch (property) {
        case "scaleX":
          this.onChange(value, path);
          applyChange("scaleY");
          applyChange("scaleZ");

          break;
        case "scaleY":
          this.onChange(value, path);
          applyChange("scaleX");
          applyChange("scaleZ");
          break;
        case "scaleZ":
          this.onChange(value, path);
          applyChange("scaleX");
          applyChange("scaleY");
          break;
      }

      return;
    }

    this.onChange(value, path);
  }

  onChange(value, path) {
    const { item, joined } = this.props;

    const groupName = joined;

    const property = path.split(".").pop();
    console.log({ id: item.id, value, property });

    if (item && item.id && groupName) {
      try {
        connection
          .invoke("SendDataToOthers", item.mixId, groupName, {
            type: "PropertyUpdate",
            id: item.id,
            property,
            value
          })
          .catch((err) => {
            return console.error(err);
          });
      } catch (e) {
        console.error(e);
      }
    }
  }

  sendUpdate(id, mixId, groupName, type) {
    if (id && groupName) {
      try {
        connection
          .invoke("SendDataToOthers", mixId, groupName, {
            type,
            id
          })
          .catch((err) => {
            return console.error(err);
          });
      } catch (e) {
        console.error(e);
      }
    }
  }

  save() {
    const { item, joined } = this.props;

    const { isValidMixId, isValidData } = validateItem(item);

    if (!isValidMixId || !isValidData) {
      notifier.notify({
        level: notifier.Level.Error,
        title: "Error",
        message: "Fix validation errors and try again"
      });

      return;
    }

    const isNew = item.id === null;

    const onSaved = (content) => {
      if (isNew) {
        this.sendUpdate(content.id, item.mixId, joined, "ItemCreated");

        notifier.notify({
          level: notifier.Level.Success,
          title: "Success",
          message: "Item created"
        });

        navigateTo(`/item/${content.id}`);
        return;
      }

      this.sendUpdate(item.id, item.mixId, joined, "ItemUpdated");

      notifier.notify({
        level: notifier.Level.Success,
        title: "Success",
        message: "Item updated"
      });

      this.update(item.id);
    };

    post("api/items", item, onSaved);
  }

  update(id) {
    const mixId = window.localStorage.getItem("mixId") || "";

    if (id === "_") {
      const item = {
        id: null,
        mixId,
        description: "",
        type: "",
        layer: "",
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1,
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        placementMode: PlacementMode.Preview,
        data: "{}"
      };

      setTimeout(
        () => AppActions.updateStates([{ statePath: "item", data: item }]),
        0
      );

      return;
    }

    get("api/items/:id", { id }, (data) => {
      AppActions.updateStates([{ statePath: "item", data: data }]);
    });
  }
}
